import React, {memo, useCallback, useMemo} from 'react';
import {Select} from 'antd';
import spain from '@/assets/images/spainFlag.png';
import ukFlag from '@/assets/images/ukFlag.png';
import {useTranslation} from 'react-i18next';
import {useUser} from '@dofleini/security';
import PropTypes from 'prop-types';

const { Option } = Select;

const options = {
  SPANISH: 'es',
  ENGLISH: 'en',
};

const GlobalLanguageSelectorProfile = ({ value, onChange, ...props }) => {
  const { t } = useTranslation('common');
  const { user } = useUser();

  const spainOption = useMemo(() => {
    return (<div className={'flex items-center justify-start'}>
      <img src={spain} alt="spainFlag" width={'20px'} height={'auto'} className={'mr-2'}/>
      <span>{t('es')}</span>
    </div>);
  }, [t]);

  const ukOption = useMemo(() => {
    return (<div className={'flex items-center justify-start'}>
      <img src={ukFlag} alt="ukFlag" width={'20px'} height={'25px'} className={'mr-2'}/>
      <span>{t('en')}</span>
    </div>);
  }, [t]);

  const onChangeGlobalLanguage = useCallback(async (val) => {
    // localStorage.setItem('i18nextLng', val);
    onChange && onChange(val);
    // await update({_id: user?._id, language: val});
    // i18n.changeLanguage(val);
  }, [onChange]);

  return (
    <Select
      key={user?._id}
      defaultValue={user?.language || value || options.SPANISH}
      value={value}
      onChange={onChangeGlobalLanguage}
      className="custom-select"
      {...props}
    >
      <Option value={options.SPANISH}>{spainOption}</Option>
      <Option value={options.ENGLISH}>{ukOption}</Option>
    </Select>
  );
};

GlobalLanguageSelectorProfile.propTypes = {
  initialValue: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  form: PropTypes.object,
};

export default memo(GlobalLanguageSelectorProfile);

const GlobalLanguageView = ({value}) => {

  const { t } = useTranslation('common');

  const spainOption = useMemo(() => {
    return (
      <div className={'flex items-center justify-start'}>
        <div className="font-bold mr-2">{t('language')}:</div>
        <img src={spain} alt="spainFlag" width={'20px'} height={'auto'} className={'mr-2'}/>
        <span>{t('es')}</span>
      </div>
    );
  }, [t]);

  const ukOption = useMemo(() => {
    return (
      <div className={'flex items-center justify-start'}>
        <div className="font-bold mr-2">{t('language')}:</div>
        <img src={ukFlag} alt="ukFlag" width={'20px'} height={'25px'} className={'mr-2'}/>
        <span>{t('en')}</span>
      </div>
    );
  }, [t]);

  if (value === 'es' || value === 'ES') return spainOption;

  return ukOption;
};

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Code component in a table cell
 * @param {String} text this is the value of the dataIndex of the table
 * */
export const renderGlobalLanguage = (text) => {
  return (
    <GlobalLanguageView value={text}/>
  );
};

/**
 * This is not a component,
 * it is a function to render the Code component in a table cell
 * @param {String} text this is the value of the dataIndex of the table
 * */
export const renderGlobalLanguageViewSelectorProfile = (value, form) => {
  return (
    <GlobalLanguageSelectorProfile value={value} form={form}/>
  );
};

